import styled from "styled-components";

export const StyledAppointmentWrapper = styled.div`
  padding: var(--spacing-md);
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
